import React, { useEffect } from "react";
import "./privacyPolicy.css";
import Meta from "utils/meta";

const PrivacyPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div className="container">
      <Meta title="Privacy Policy | The Realtor Desk" description="" />
      <div className="privacyPolicy-container">
        <div className="privacyPolicy-heading">
          <h1>Privacy Policy</h1>
        </div>
        <div className="privacyPolicy-content">
          <h3>General:</h3>
          <p>
            At The Realtor Desk, we respect your need for online privacy and
            protect any Personal and "Confidential Information" that you may
            share with us, in an appropriate manner.“Confidential Information”
            means the information (contact name, phone, mobile, fax numbers,
            address,flat no, building name and email address) that is
            proprietary to the disclosing party and not generally known to the
            public. Our practice as regards use of your Personal Information is
            as set forth below in this Privacy Policy Statement. As a condition
            to use of The Realtor Desk Services, you consent to the terms of the
            Privacy Policy Statement as it may be updated from time to time. In
            the event of a material change, we shall notify you via email or by
            means of a prominent notice on the website. This Privacy Policy
            Statement applies exclusively to therealtordesk.com
          </p>

          <h3>Personal Information:</h3>
          <p>
            During the Registration Process for creating a user account, we
            request for your name,mobile number and email address etc, which
            will be used solely for the purpose of providing access to your user
            account. Your name,mobile number and email address will be used to
            inform you regarding new services, releases, upcoming events and
            changes in this Privacy Policy Statement.In doing so, no Personal
            Information within your third party email accounts is transferred to
            your user account without your explicit consent.
          </p>

          <h3>Confidential Information of your User Account:</h3>
          <p>
            We store and maintain files, documents, to-do lists, emails and
            other data stored in your user account at our facilities. In order
            to prevent loss of data due to errors or system failures, we also
            keep backup copies of data including the contents of your user
            account. We assure you that the contents of your user account will
            not be disclosed to anyone and will not be accessible even to
            employees of The Realtor Desk except in circumstances specifically
            like, a worldwide license to store, modify, create derivative works
            (such as those resulting from translations, adaptations or other
            changes we make so that your content works better with our Services
            for you) or if required by law, regulation or court order; in which
            case, the party being compelled to disclose Confidential Information
            will give the other party as much notice as is reasonably
            practicable prior to disclosing the Confidential Information. 
          </p>
          <p>
            The Realtor Desk is committed to protecting your privacy and
            understand your business domain hence we also do not process the
            contents of your user account for serving targeted , analysis
            ,advertisements, marketing strategies,real estate construction,
            projections for future operations, financial information or any real
            estate activities. 
          </p>
          <p>
            In short, neither party will use or disclose the other party's
            Confidential Information without the other's prior written consent
            except for the purpose of performing its obligations under this
            Agreement
          </p>

          <h3>Cookies:</h3>
          <p>
            The Realtor Desk uses cookies to distinguish you from other users of
            a The Realtor Desk Website. This helps us to provide you with a good
            experience when you browse our websites and also allows us to
            improve our sites. For detailed information on the type of cookies
            we use and the purposes for which we use them. By using this Site,
            http://www.therealtordesk.com, or any other The Realtor Desk
            Website, you accept the use of cookies in accordance with the The
            Realtor Desk Cookie Notice. If you do not accept the use of cookies,
            please disable them following the instructions in the Cookie Notice,
            by changing your browser settings so that cookies cannot be placed
            on your computer or mobile device.
          </p>

          <h3>With whom we share Information:</h3>
          <p>
            We may need to disclose "Confidential Information" to our
            affiliates, service providers and business partners solely for the
            purpose of providing The Realtor Desk Services to you. In such cases
            The Realtor Desk will also ensure that such affiliates, service
            providers and business partners comply with this Privacy Policy
            Statement and adopt appropriate confidentiality and security
            measures. We will obtain your prior specific consent before we share
            or disclose your "Confidential Information" to any person outside
            The Realtor Desk for any purpose that is not directly connected with
            providing The Realtor Desk Services to you. Please be aware that
            laws in various jurisdictions in which we operate may obligate us to
            disclose user information and the contents of your user account to
            the local law enforcement authorities under a legal process or an
            enforceable government request. In addition, we may also disclose
            Personal Information and contents of your user account to law
            enforcement authorities if such disclosure is determined to be
            necessary by The Realtor Desk in our sole and absolute discretion
            for protecting the safety of our users, employees, or the general
            public.
          </p>

          <h3>How secure is your data:</h3>
          <p>
            We adopt industry appropriate data collection, storage and
            processing practices and security measures, as well as physical
            security measures to protect against unauthorized access,
            alteration, disclosure or destruction of your Personal Information,
            username, password, transaction information and data stored in your
            user account. Access to your name and email address is restricted to
            our employees who need to know such information in connection with
            providing The Realtor Desk Services to you and are bound by
            confidentiality obligations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
